import './assets/_variables.css';

import { DefaultApolloClient } from '@vue/apollo-composable';
// import naive from 'naive-ui';
import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { apolloClient } from './apolloClient';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
// import themeOverrides from './theme-overrides'

const app = createApp(App);

app.provide(DefaultApolloClient, apolloClient);
app.use(createPinia());

// app.use(naive);
app.use(router);
app.use(i18n);
app.mount('#app');
